export default __webpack_public_path__ + "static/media/guest_user_modal_img.92ce6fa6.png";